import React from "react";
import cn from "classnames";

interface HamburgerProps {
  showMobileNav?: boolean;
}

const Hamburger: React.FC<HamburgerProps> = props => {
  const { showMobileNav } = props;
  return (
    <div className="h-[17px] w-[24px] relative cursor-pointer">
      <div
        className={cn(
          "bg-gray-3-dark absolute w-full h-[3px] rounded-sm top-0 transition-all transition-delay-600 ease-in-out",
          showMobileNav
            ? "rotate-45 translate-y-[8px]"
            : "rotate-0 translate-y-[0]"
        )}
      ></div>
      <div
        className={cn(
          "bg-gray-3-dark absolute w-full h-[3px] rounded-sm translate-y-[-2px] top-[40%] transition-all transition-delay-600 ease-in-out",
          showMobileNav
            ? "rotate-45 !translate-y-[1px]"
            : "rotate-0 translate-y-[0]"
        )}
      ></div>
      <div
        className={cn(
          "bg-gray-3-dark absolute w-full h-[3px] rounded-sm bottom-0 transition-all transition-delay-600 ease-in-out",
          showMobileNav
            ? "rotate-[-46deg] translate-y-[-6px] translate-x-[-0.2px]"
            : "rotate-0 translate-y-[0]"
        )}
      ></div>
    </div>
  );
};

export default Hamburger;
